// Label for a count badge on a sidebar nav item.
//
// Zero is deliberately no badge rather than a "0": an empty queue should read
// as nothing waiting, not as a number the eye still has to stop and check. The
// cap keeps the badge a fixed width, so a busy queue doesn't push the item
// label around, and an absent or broken count degrades to no badge rather than
// to "NaN" in the sidebar.
export function navBadgeLabel(count) {
  const n = Number(count);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n > 99 ? '99+' : String(Math.floor(n));
}

// The badges under a collapsed section or group, summed, so folding the menu
// away does not hide a waiting action. `countsById` maps a page id to its
// { open, overdue }; items inside a group count too. A count that has not
// arrived, or is broken, adds nothing.
export function sumNavBadges(items, countsById) {
  const total = { open: 0, overdue: 0 };
  const add = (n) => (Number.isFinite(Number(n)) && Number(n) > 0 ? Number(n) : 0);
  for (const item of items || []) {
    if (item.children) {
      const inner = sumNavBadges(item.children, countsById);
      total.open += inner.open; total.overdue += inner.overdue;
    } else if (countsById?.[item.id]) {
      total.open += add(countsById[item.id].open);
      total.overdue += add(countsById[item.id].overdue);
    }
  }
  return total;
}

export default navBadgeLabel;
